var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCrescent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1655 18.9026C18.7803 19.8961 16.0982 19.9014 13.7092 18.9174C11.3201 17.9334 9.41979 16.0406 8.42628 13.6555C7.43277 11.2703 7.42744 8.5882 8.41146 6.19914C9.39549 3.81008 11.2883 1.90977 13.6734 0.916255C13.8323 0.840261 14.0271 0.760675 14.2205 0.681233C14.393 0.610386 14.3726 0.377914 14.1901 0.340042C11.9559 -0.123425 9.62734 0.126559 7.53626 1.06238C6.06249 1.65377 4.7213 2.53285 3.59101 3.64828C2.46071 4.76371 1.56396 6.09315 0.953109 7.55896C0.342257 9.02478 0.0295464 10.5976 0.0332354 12.1856C0.0369243 13.7736 0.356939 15.345 0.974594 16.8079C1.59225 18.2709 2.49517 19.5961 3.63063 20.7063C4.7661 21.8165 6.11136 22.6893 7.58786 23.2738C9.06436 23.8584 10.6425 24.1429 12.2302 24.1108C13.8179 24.0788 15.3833 23.7307 16.8349 23.087C18.9444 22.2416 20.7382 20.7772 21.9874 18.8987C22.1099 18.7145 21.8638 18.4971 21.6759 18.6139C21.51 18.7171 21.3397 18.8134 21.1655 18.9026Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrescent);
export default __webpack_public_path__ + "static/media/crescent.e18244cb77e62d9e731cc6dc6170f61c.svg";
export { ForwardRef as ReactComponent };